var _styled;

import styled from 'react-emotion';
import React from 'react';
import { BLUE, WHITE } from 'govuk-colours';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledBadge = styled('strong')((_styled = {
  display: 'inline-block',
  margin: '0 8px 0 0',
  padding: '2px 5px',
  fontFamily: NTA_LIGHT,
  fontWeight: 700,
  fontSize: FONT_SIZE.SIZE_14,
  lineHeight: LINE_HEIGHT.SIZE_14,
  textTransform: 'uppercase',
  letterSpacing: '1px',
  textDecoration: 'none',
  color: WHITE,
  backgroundColor: BLUE,
  WebkitFontMmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16,
  paddingBottom: 0
}, _styled));
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <PhaseBadge>beta</PhaseBadge>
 * ```
 *
 * ### References:
 * - https://govuk-elements.herokuapp.com/alpha-beta-banners/
 *
 */

var PhaseBadge = function PhaseBadge(props) {
  return React.createElement(StyledBadge, props);
};

export default withWhiteSpace({
  marginBottom: 0
})(PhaseBadge);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/phase-badge/es/index.js
// module id = 70
// module chunks = 0